<template>

    <div  class="content-warp block">
<!--        <div style="padding: 15px;font-size: 14px">我的</div>-->


        <div class="text-warp">
            <div></div>

            <van-cell-group style="background-color: #6685a4;">
                <van-row gutter="10" style="padding: 20px;">
                    <van-col span="8">
                        <van-image width="80" height="80" :src="wximage" round style="margin: 10px 0 0 10px"/>
                    </van-col>
                    <van-col span="16" style="margin-top:10px">
                        <p class="subtitle">{{userName}}</p>
                        <p class="subtitle">{{showPhone()}}</p>
                        <p class="subtitle">{{showid()}}</p>
                    </van-col>
                </van-row>


            </van-cell-group>
            <van-cell-group style="margin-top: 10px;font-size: 16px">
                <van-cell icon="edit"  @click="chagePhone()" title="更换手机号码" is-link value="" title-style="font-size:16px;padding-left:10px"/>
                <!--<van-cell title="帮助中心" is-link  value="内容" title-style="font-size:24px" @click="testLocal()"/>-->
                <van-cell icon="exchange" title="退出" is-link value="" @click="logout()" title-style="font-size:16px;padding-left:10px"/>
            </van-cell-group>
        </div>

        <van-popup v-model="showpop" position="right" :style="{ height: '100%', width:'80%'}" >
            <van-form >

                <van-field style="font-size: 16px;"
                           v-model="newPhoneNumber"
                           name="newPhoneNumber"
                           left-icon="phone-o"
                           label=" "
                           label-width="5px"
                           placeholder="请输入新的手机号码"
                />
                <van-field style="font-size: 16px"
                           v-model="smsCode"
                           type="number"
                           name="smsCode"
                           left-icon="comment-o"
                           label=" "
                           label-width="5px"
                           placeholder="请输入验证码"
                >
                    <template #button>
                        <a style="color: #6685a4;margin-right: 6px" @click="sendMsg()">{{buttonTxt}}</a>
                        <!--<van-button  size="small" type="info" :disabled="buttonStatus" @click="sendMsg()">{{buttonTxt}}</van-button>-->
                    </template>
                </van-field>
                <div style="margin: 16px;">
                    <van-button  block  type="info" native-type="submit" style="font-size: 16px" @click="changeUser()">
                        提交
                    </van-button>
                </div>
            </van-form>
        </van-popup>

    </div>
</template>

<script>
    import { Field } from 'vant';
    import { Form,Cell, CellGroup,Image,Button } from 'vant';
    import { Dialog } from 'vant';
    import { Toast } from 'vant';
    import { Col, Row } from 'vant';
    import { Popup } from 'vant';
    import { Overlay } from 'vant';
    import { Loading } from 'vant';

    import service from '../server/index'
    // import qs from 'qs';
    export default {
        name: "User",
        components:{
            [Field.name]:Field,
            [Cell.name]:Cell,
            [Form.name]:Form,
            [CellGroup.name]:CellGroup,
            [Dialog.Component.name]: Dialog.Component,
            [Image.name]:Image,
            [Toast.name]:Toast,
            [Col.name ]:Col,
            [Row.name ]:Row,
            [Popup.name ]:Popup,
            [Button.name]:Button,
            [Overlay.name]: Overlay,
            [Loading.name]: Loading
        },
        data() {
            return {
                tel: '',
                text: '',
                digit: '',
                number: '',
                password: '',
                wximage: localStorage.getItem("userImage"),
                userName:localStorage.getItem("personName"),
                telPhone:localStorage.getItem("phoneNumber"),
                deliveryIdnumber:localStorage.getItem("deliveryIdnumber"),
                showpop:false,
                username: '',
                smsCode: '',
                buttonTxt:"获取验证码",
                buttonStatus:false,
                smstime:0,
                timer:-1,
                show: false,
                checked:true,
                newPhoneNumber:""
            };
        },
        computed:{
            showPhone(){
                return function(){
                    var start= this.telPhone.substring(0,3);
                    var stringlength = this.telPhone.length
                    var end= this.telPhone.substring(stringlength-4, stringlength);
                    return start+"****"+end;
                }
            },
            showid(){
                return function(){
                    var start= this.deliveryIdnumber.substring(0,4);
                    var stringlength = this.deliveryIdnumber.length;
                    var end= this.deliveryIdnumber.substring(stringlength-4, stringlength);
                    return start+"**********"+end;
                }
            }
        },
        methods:{
            testLocal(){
                Toast('提示内容');
            },
            logout(){
                Dialog.confirm({
                    title: '提示消息',
                    message: '确定要退出系统吗？',
                    confirmButtonColor:"#6685a4"
                })
                    .then(() => {
                        this.$store.dispatch('logout')

                        this.$router.replace('/thlogin')
                    })
                    .catch(() => {
                        // on cancel
                    });

            },
            chagePhone(){
            this.showpop=true

            },
            changeUser(){
                let myreg = /^(13[0-9]{9})|(15[0-9]{9})|(17[0-9]{9})|(18[0-9]{9})|(19[0-9]{9})$/;
                if(this.newPhoneNumber=="" || this.newPhoneNumber==""){

                    Toast('手机号码或验证码不能为空');
                    return ;
                }
                if (!myreg.test(this.newPhoneNumber)) {
                    Toast('请输入正确格式的手机号码');
                    return ;
                }

                let param={
                    deliveryUserId:localStorage.getItem("deliveryId"),
                    phoneNumber:this.newPhoneNumber,
                    smsCode:this.smsCode,
                }
                service.changeUserV2(param).then(res=>{
                    if(res.code==200){
                        Dialog.alert({
                            title: '修改成功'
                        })
                        this.$router.replace('/thLogin');

                    }else{
                        Dialog.alert({
                            title: '修改失败：'+res.msg,
                        })
                    }

                }).catch(res=>{
                    alert(res);
                })


            },
            sendMsg(){
                let myreg = /^(13[0-9]{9})|(15[0-9]{9})|(17[0-9]{9})|(18[0-9]{9})|(19[0-9]{9})$/;
                if (this.newPhoneNumber == '') {
                    Toast('手机号码不能为空');
                    return false
                } else {
                    if (!myreg.test(this.newPhoneNumber)) {
                        Toast('请输入正确格式的手机号码');
                        return false
                    }

                }

                let param={
                    phoneNumber:this.newPhoneNumber,
                    bussnissType:'deliverResetCode'
                }
                service.getLoginCode(param).then(res=>{
                    if(res.code==200){
                        Toast('发送成功');

                    }else{
                        Toast('发送失败');
                    }

                }).catch(res=>{
                    alert(res);
                })

                this.smstime=15;
                this.buttonStatus=true;
                this.timer = setInterval(() => {          //
                    this.smstime--;
                    this.buttonTxt=this.smstime+"秒后重试";
                    if(this.smstime <= 0) {
                        this.smstime = 0
                        this.buttonStatus=false;
                        this.buttonTxt="重新获取"
                        clearInterval(this.timer);
                    }
                    if(this.smstime==10){
                        Toast('验证码:1');
                    }
                }, 1000)
            }
        }
    }
</script>

<style scoped>
    .subtitle{
        font-size: 16px;
        color:white;
        font-weight: bolder;
        margin-top: 0px;
        margin-bottom: 10px;
        padding:0px !important;
    }
    .block{
        top:0px;
        width:100%;
        height: 100vh;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
    }
    .content-warp{
        background-color: #f7f8fa;
        text-align: left;

    }
    .text-warp{
        margin: 0px auto 0 auto;
    }
    .van-cell__right-icon{
      color:#6685a4;
    }
    /deep/ .van-image__img{
        border-radius: 50%;
    }

    /deep/ .van-button--info ,
    /deep/ .van-button--danger{
        /*background-color: #6685a4 ;*/
        /*border: 1px solid #6685a4 ;*/
        background-color: white;
        border: 1px solid white;
        color:#6685a4;

    }
</style>
